import React, { useState } from 'react'
import { EntryPage, PasswordRecoveryForm, NavBar as PublicNavBar } from '@emerald-works-nova/auth'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { Grid } from '@mui/material'
import { routes } from '../../../routes'

const ForgotPasswordFormPage = ({ onFinalize }) => {
  const [isResetting, setIsResseting] = useState(false)

  const [sendForgotPasswordEmail] = useEvent([{
    eventName: 'userSendForgotPasswordEmail',
    onSuccess: () => {
      setIsResseting(false)
      onFinalize()
    },
    onError: () => {
      setIsResseting(false)
      onFinalize()
    }
  }])

  function handleRecoverPassword ({ email }) {
    setIsResseting(true)
    const verifyUrl = window.location.host

    sendForgotPasswordEmail.trigger({
      email,
      verifyUrl
    })
  }

  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
    >
      <Grid item style={{ minHeight: 85 }}>
        <PublicNavBar
          captionText="Don't have an account?"
          link={routes.register.path}
          buttonText='Sign up'
        />
      </Grid>
      <Grid item>
        <EntryPage
          title='Forgot your password?'
          showMtLogo
          subtitle='Enter your email address below and we’ll get you back on track.'
          content={
            <PasswordRecoveryForm onRecoverPassword={handleRecoverPassword} isResetting={isResetting} />
          }
          application={process.env.REACT_APP_APPLICATION_NAME}
        />
      </Grid>
    </Grid>
  )
}

export default ForgotPasswordFormPage
